import React from "react";
import { ForwardButton } from "~/assets/js/components/Button";
import categories from "~/assets/js/Helpers/categories";

const Categories = () => {
    return (
        <div className="footer_categories">
            {categories.map((category) => {
                return (
                    <ForwardButton
                        customStyle={"category_btn"}
                        key={category.content}
                        label={category.content}
                        href={category.href}
                        variant="category"
                        size={"SM"}
                    />
                );
            })}
        </div>
    );
};

export default Categories;
